import * as React from 'react'

function WarningIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M12 17.161a.875.875 0 01-.875-.875V10.85A.887.887 0 0112 9.975a.887.887 0 01.875.875v5.436a.875.875 0 01-.875.875zM12 8.588a.887.887 0 00.875-.875.875.875 0 00-1.75 0 .887.887 0 00.875.875z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 20.227a8.227 8.227 0 100-16.454 8.227 8.227 0 000 16.454zM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z'
        fill='currentColor'
      />
    </svg>
  )
}

export default WarningIcon
